"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_config_1 = require("@8x8/oxygen-config");
function getIconColor({ active, color, disabled, invertColors, link, selected, theme, }) {
    if (color) {
        return `fill: ${color}`;
    }
    if (disabled) {
        return `fill: ${invertColors ? theme.disabledInvertColor : theme.disabledColor}`;
    }
    if (active) {
        return `fill: ${invertColors ? theme.hoverInvertColor : theme.hoverColor}`;
    }
    if (selected) {
        return `fill: ${invertColors ? theme.selectedInvertColor : theme.selectedColor}`;
    }
    if (link) {
        return `fill: ${invertColors ? theme.linkInvertColor : theme.linkColor}`;
    }
    return `fill: ${invertColors ? theme.noLinkInvertColor : theme.color}`;
}
const StyledComponent = styled_components_1.default.svg `
  height: ${({ size, theme }) => (size ? `${size}px` : theme.size)};
  width: ${({ size, theme }) => (size ? `${size}px` : theme.size)};
  cursor: ${({ link, disabled }) => link && !disabled && 'pointer'};
  user-select: ${({ link }) => (link ? 'none' : 'auto')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  ${getIconColor};

  ${({ theme, invertColors, link }) => link
    ? `
    &:hover {
    ${getIconColor({
        theme,
        invertColors,
        link,
        active: true,
    })};
    }

    &:focus {
    ${getIconColor({
        theme,
        invertColors,
        link,
        active: true,
    })};
    }

    &[disabled] {
    ${getIconColor({
        theme,
        invertColors,
        link,
        disabled: true,
    })};
    }
  `
    : ''}
`;
const Icon = props => {
    const { children, title, forwardedRef, ...rest } = props;
    const { theme } = rest;
    return (react_1.default.createElement(StyledComponent, { role: "img", ...rest, viewBox: theme.viewBox, ref: forwardedRef },
        title && react_1.default.createElement("title", null, title),
        children));
};
Icon.propTypes = {
    active: prop_types_1.default.bool,
    children: prop_types_1.default.node,
    color: prop_types_1.default.string,
    invertColors: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    link: prop_types_1.default.bool,
    selected: prop_types_1.default.bool,
    size: prop_types_1.default.number,
    title: prop_types_1.default.string,
    theme: prop_types_1.default.object.isRequired,
};
Icon.defaultProps = {
    active: false,
    children: undefined,
    disabled: false,
    color: null,
    forwardedRef: null,
    invertColors: false,
    link: false,
    selected: false,
    size: null,
    title: undefined,
};
exports.default = (0, oxygen_config_1.withTheme)(Icon, 'icon');
